import { useMemo } from 'react'
import { resolveAccess } from './resolveAccess'
import { ROUTE_REGISTRY_ENTRIES } from './routeRegistry'
import { useAccessSources } from './useAccessSources'
import type { AccessAnswer } from './accessRules'
import type { RouteKey } from '@omnea-app/fe-routing/routes/routeKeys'

/**
 * What every route answers for the current caller, so enforcement and the links that point at a route
 * cannot disagree.
 */
export const useRouteAccess = (): ReadonlyMap<RouteKey, AccessAnswer> => {
  const sources = useAccessSources()

  return useMemo(() => {
    const answers = new Map<RouteKey, AccessAnswer>()

    for (const [key, definition] of ROUTE_REGISTRY_ENTRIES) {
      answers.set(key, resolveAccess(definition, sources))
    }

    return answers
  }, [sources])
}
